module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-style"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('h4', {
    staticClass: "text-primary",
    staticStyle: {
      "margin-left": "15px",
      "margin": "10px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.carehomeName) + " " + _vm._s(_vm.çarehomeId))])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'charts',
        params: {
          carehomeid: _vm.carehomeId
        }
      }
    }
  }, [_vm._v("\n                Print Charts\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'carehome-dispensation',
        params: {
          carehomeid: _vm.carehomeId
        }
      }
    }
  }, [_vm._v("\n                MAR Status\n            ")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fe8e6b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe8e6b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/CarehomeHeader/CarehomeHeader.scp.html
// module id = 447
// module chunks = 0